/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_tip_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 72 bill with a 15% tip = 10.80 tip, 82.80 total.`)
};

const es_pct_tip_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una cuenta de 72 con una propina del 15% = 10,80 de propina, 82,80 en total.`)
};

const de_pct_tip_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Rechnung über 72 mit 15% Trinkgeld = 10.80 Trinkgeld, 82.80 gesamt.`)
};

const nl_pct_tip_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een rekening van 72 met 15% fooi = 10.80 fooi, 82.80 totaal.`)
};

const fr_pct_tip_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une addition de 72 avec un pourboire de 15 % = 10,80 de pourboire, 82,80 au total.`)
};

const it_pct_tip_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un conto di 72 con una mancia del 15% = 10.80 di mancia, 82.80 totale.`)
};

const pt_br2_pct_tip_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma conta de 72 com 15% de gorjeta = 10.80 de gorjeta, 82.80 no total.`)
};

const pt_pct_tip_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma conta de 72 com uma gorjeta de 15% = 10.80 de gorjeta, 82.80 no total.`)
};

const ja_pct_tip_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`72の会計に15%のチップ = チップ10.80、合計82.80。`)
};

const zh_pct_tip_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`72 的账单加 15% 小费 = 10.80 小费，总额 82.80。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_tip_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_tip_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_tip_ex3", locale)
	if (locale === "en") return en_pct_tip_ex3(inputs)
	if (locale === "es") return es_pct_tip_ex3(inputs)
	if (locale === "de") return de_pct_tip_ex3(inputs)
	if (locale === "nl") return nl_pct_tip_ex3(inputs)
	if (locale === "fr") return fr_pct_tip_ex3(inputs)
	if (locale === "it") return it_pct_tip_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_pct_tip_ex3(inputs)
	if (locale === "pt") return pt_pct_tip_ex3(inputs)
	if (locale === "ja") return ja_pct_tip_ex3(inputs)
	return zh_pct_tip_ex3(inputs)
};